var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'border-t border-neutral-50 first:border-transparent',
    { 'p-5 md:p-8': _vm.defaultPadding } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }